(function () {
	const header = () => {
		const megaMenuLinks = document.querySelectorAll(".list-menu--megamenu");
		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", () => {
				link.classList.add("list-menu--megamenu-visible");

				link.addEventListener("mousemove", () => {
					link.classList.add("list-menu--megamenu-visible");
				});

				link.addEventListener("mouseleave", () => {
					setTimeout(() => {
						link.classList.remove("list-menu--megamenu-visible");
					}, 300);
					link.addEventListener("mouseenter", () => {
						link.classList.add("list-menu--megamenu-visible");
					});
				});
			});
		});
	};

	document.addEventListener("shopify:section:load", header);

	header();
})();




document.addEventListener("DOMContentLoaded", function() {
    // Seleziona il bottone per chiudere il menu
    var closeButton = document.getElementById('close-menu-button');

    // Seleziona il menu-drawer
    var menuDrawer = document.querySelector('.menu-drawer'); // Modifica '.menu-drawer' con il selettore corretto

    // Aggiungi un listener per l'evento di click sul bottone
    closeButton.addEventListener('click', function() {
        // Controlla se il menu-drawer è visibile e chiudilo
        if (menuDrawer && menuDrawer.classList.contains('is-visible')) { // Modifica 'is-visible' con la classe corretta che indica che il menu è aperto
            menuDrawer.classList.remove('is-visible');
        }
        // Rimuovi la classe overflow-hidden dal body
        document.body.classList.remove('overflow-hidden-tablet');
        document.body.classList.remove('overflow-hidden-mobile');
    });

    // Aggiungi un listener per l'evento di click sul documento
    document.addEventListener('click', function(event) {
      // Controlla se il click è avvenuto al di fuori del menu-drawer
      if (menuDrawer && menuDrawer.classList.contains('is-visible') && !menuDrawer.contains(event.target) && event.target !== closeButton) {
          menuDrawer.classList.remove('is-visible');
          
          document.body.classList.remove('overflow-hidden-tablet');
          document.body.classList.remove('overflow-hidden-mobile');
      }
  });


    
  var utilityName = document.getElementById('utility-name');
  var accountBody = document.getElementById('utility-account-body');

  if (utilityName && accountBody) {
    utilityName.addEventListener('click', function() {
      accountBody.classList.toggle('is-visible');
    });
  } 
 /* else {
    console.error('Elementi non trovati');
  }*/
});


$(document).ready(function() {
    if ($(window).width() >= 1200) {

    // const $shopButton = $('.header__shop-button');
    const $shopButton = $('.header__icon--menu');
    const $menuDrawer = $('.menu-drawer');
  
    $shopButton.on('click', function() {
        $('body').addClass('menu-drawer-open');
    });
  
    const $menuMacros = $('.menu-drawer__menu-macro');
  
    $menuMacros.each(function() {
        const $submenu = $(this).find('.menu-drawer__submenu');
  
        $(this).on('mouseenter', function() {
            // Chiudi tutti gli altri sottomenu
            $menuMacros.find('.menu-drawer__submenu-cat2').removeClass('motion-reduce--open');
            $menuMacros.find('.details-macro').removeAttr('open');
            
            // Apri il sottomenu corrente
            $(this).find('.menu-drawer__submenu-cat2').addClass('motion-reduce--open');
            $(this).find('.details-macro').attr('open', true);

        });
        
    }); 

    const $shopWrapper = $('.header__shop-wrapper');

    $menuDrawer.on('click', function() {
        // const $menus = $('.menu-desktop');
        const $menus = $('.menu-drawer-container');

        $menuDrawer.on('click', function(event) {
            if (!$(event.target).closest('.menu-drawer__inner-container').length && !$(event.target).closest('.menu-drawer__submenu').length) {
                $menus.removeAttr('open');
                $menuMacros.find('.menu-drawer__submenu-cat2').removeClass('motion-reduce--open');
                $menuMacros.find('.details-macro').removeAttr('open');
                $('body').removeClass('menu-drawer-open');
            }
        });
    });
};
});
